var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2C0.721933 2 0.5 2.2246 0.5 2.50165V13.4984C0.5 13.7744 0.722241 14 0.996391 14H16.0036C16.2738 14 16.5 13.7754 16.5 13.4984V2.50165C16.5 2.22564 16.2768 2 16.0015 2H12.5L11.7219 0.443865C11.5995 0.19908 11.2756 0 10.9988 0H6.00124C5.72788 0 5.40064 0.198725 5.27807 0.443865L4.5 2H4V1H1.5V2H1ZM4 8C4 10.4853 6.01472 12.5 8.5 12.5C10.9853 12.5 13 10.4853 13 8C13 5.51472 10.9853 3.5 8.5 3.5C6.01472 3.5 4 5.51472 4 8ZM11 8C11 9.38071 9.88071 10.5 8.5 10.5C7.11929 10.5 6 9.38071 6 8C6 6.61929 7.11929 5.5 8.5 5.5C9.88071 5.5 11 6.61929 11 8ZM14 4C13.7239 4 13.5 4.22386 13.5 4.5C13.5 4.77614 13.7239 5 14 5H15C15.2761 5 15.5 4.77614 15.5 4.5C15.5 4.22386 15.2761 4 15 4H14Z",
    fill: "#005F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoBlue);
export default __webpack_public_path__ + "static/media/photo_blue.1608b9e2d772af175ebdb378b78397ad.svg";
export { ForwardRef as ReactComponent };